
import data from "@/mixins/data.js"

export default {
  name: "StepTab1",
  mixins: [data],
}
